import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Alert({
  icon,
  alertText,
  alertSubtext,
  containerClass,
}) {
  return (
    <div className={classNames('rounded-md', containerClass)}>
      <div className="flex items-center justify-center">
        <FontAwesomeIcon
          icon={icon}
          className="h-5 w-5 text-negative-red"
          aria-hidden="true"
        />
        <div className="ml-3">
          <h3 className="text-sm font-avenir-medium text-negative-red mt-0.5">
            {alertText}
          </h3>
          {alertSubtext}
        </div>
      </div>
    </div>
  );
}
